import React, { Fragment } from "react";
import { Switch, Route } from "react-router";
// Redux
import { connect } from "react-redux";
import { showModal, hideModal } from "store/state/modals/modal";
import { openNotes } from "store/state/note";
// MUI
import { AppBar, Tab, Tabs, Toolbar } from "@material-ui/core";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";

// Routes
import { PIPELINE , PIPELINE_DEAD } from "constants/routes";
import PrivateRoute from "components/PrivateRoute";

// Components
import ActiveDeals from "./ActiveDeals";
import DeadDeals from "./DeadDeals";
import PensfordNotes from "../Notes/PensfordNotes";
import NewDealButton from "./NewDealButton";

//Widget Tiles
import MetricTile from "components/Global/Metric/MetricTile";
import { getScreenPreferences } from "../../shared-utility/store/state/screenPreferences";

const styles = () => ({
  tabsRoot: {
    marginLeft: 20,
    marginTop: 10
  },
  tabRoot: {
    fontWeight: 400,
    borderBottom: "none",
    textTransform: "capitalize",
    minWidth: 100,
    color: "#009DDF",
  },
  tabSelected: {
    fontWeight: "bold",
    borderBottom: "none"
  }
});

const PaddedDiv = styled.div`
  padding: 32px 16px;
`;
class Pipeline extends React.Component {
  state = {
    tabValue: 0,
    view: "list"
  };

  listView = () => {
    this.setState({ view: "list" });
  };

  tileView = () => {
    this.setState({ view: "tile" });
  };

  componentDidMount() {
    if (this.props.location.pathname === "/pipeline/dead") {
      this.setState({ tabValue: 1 });
    }
    this.props.getScreenPreferences({
      screenType: "pipeline_deal_table"
    });
    this.props.getScreenPreferences({
      screenType: "dead_deal_table"
    });
  }

  handleTabChange = (event, value) => {
    this.setState({ tabValue: value });
    switch (value) {
      case 1:
        this.props.history.push("/pipeline/dead");
        break;
      default:
        this.props.history.push("/pipeline");
        break;
    }
  };

  render() {
    const { classes, loading} = this.props;
    const { tabValue } = this.state;

    return (
      <Fragment>
        <h3 style={{ marginLeft: "18px" }}>Pipeline Summary</h3>
        <PaddedDiv>
          <PensfordNotes />
          <AppBar
            position="static"
            style={{
              backgroundColor: "#fff",
              color: "#606061",
              boxShadow: "none",
              height: "50px"
            }}
          >
            <Toolbar
              style={{
                justifyContent: "flex-start",
                minHeight: "50px",
                paddingLeft:0
              }}
            >
              <Tabs
                value={tabValue}
                onChange={this.handleTabChange}
                classes={{ root: classes.tabsRoot }}
                style={{
                  marginLeft:0
                }}
              >
                <Tab
                  disableRipple
                  id="pipelineTab"
                  label="PIPELINE"
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.tabSelected
                  }}
                />
                <Tab
                 disableRipple
                 id="deadTab"
                 label="DEAD"
                 classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected
                }}
                />
              </Tabs>
              <NewDealButton/>
            </Toolbar>
            <Switch>               
                <PrivateRoute systemAdmin companyAdmin user authentication={this.props.authentication} exact path={PIPELINE}  Component={ActiveDeals} deals={this.props.deal} /> 
                
                <PrivateRoute systemAdmin companyAdmin user  authentication={this.props.authentication} path={PIPELINE_DEAD}  Component={DeadDeals} />
            </Switch>
          </AppBar>
        </PaddedDiv>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, deal, screenPreferences, loading }) => ({
  authentication,
  deal,
  screen_pref: screenPreferences.screen_pref.pipeline_metric || null,
  metricData: [],
  loading
});

export default connect(
  mapStateToProps,
  {    
    getScreenPreferences
  }
)(withStyles(styles)(Pipeline));
